<template>
    <mu-flat-button label="文本框" primary style="border-bottom:1px solid gray;" />
</template>
<script>
export default {
    name: 'textField'
}
</script>



// WEBPACK FOOTER //
// textField.vue?2ccd95fe